<template>
  <div>
    <!-- <top></top> -->
    <!-- start -->
    <div class="topContent">
      <div class="content bgImgCss">
        <img :src="bgImg" alt class="imgSrcCss">
        <div class="contentPosition">
          <div class="contentTop">costa</div>
          <div class="contentBottom">
            <div>咖啡连锁品牌的智慧餐牌升级。</div>
          </div>
        </div>
      </div>
    </div>
    <!-- end -->
    <!-- 面包屑 start -->
    <!-- <Bread :breadChild="toBreadChild"></Bread> -->
    <!-- 面包屑 end -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:38px">项目背景</div>
      <div class="lineCss"></div>
    </div>
    <!-- start -->
    <!-- start -->
    <div class="productParent marginTop109">
      <div class="productLeft">
        <img :src="productLeft1" class="rightImgCss">
      </div>
      <div class="productRight">
        <div class="productRightTitle">
          <div class="titleBox1">
            <!-- <div class="anliTitle">项目背景</div>
            <div class="lineCss1"></div>-->
          </div>
        </div>
        <div
          class="productRightText paddingRight"
        >Costa，是一家诞生于欧洲的连锁咖啡品牌，2006年入驻中国市场。随着国内咖啡市场的增长，竞争日益激烈，Costa意识到需要积极做出改变，以应对多变的市场。数拓帮助Costa打造交互型数字餐牌，联屏播放动态广告，识别到人切换至菜单，为店铺带来更多活力。</div>
      </div>
    </div>
    <!-- end -->

    <!-- <div class="grayBox">
      <div class="titleBox" style="margin-top:0;">
        <div class="anliTitle">方案策略</div>
        <div class="lineCss"></div>
      </div>
      <div
        class="grayBoxText"
    >-->
    <!-- 数拓分析童装消费行为逻辑，从面向店外的针对性家长会员引流，到进店后增加儿童顾客留店时长，再到选购时通过产品溯源对购买率的提升。洞察童装消费本质，以智屏赋能门店，帮助小猪班纳增加消费率的同时，提升会员转化与品牌影响力。</div> -->
    <!-- detailList start -->
    <!-- <div class="detailList">
        <div class="detailBox">
          <img :src="detailListIcon1" alt>
          <div class="detailBoxTitle">数拓智屏OS</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon2" alt>
          <div class="detailBoxTitle">第三方系统对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon3" alt>
          <div class="detailBoxTitle">第三方硬件兼容</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon4" alt>
          <div class="detailBoxTitle">天猫数据对接</div>
        </div>
        <div class="detailBox">
          <img :src="detailListIcon5" alt>
          <div class="detailBoxTitle">场景app</div>
        </div>
    </div>-->
    <!-- detailList end -->
    <!-- </div> -->
    <!-- 场景解析 start -->
    <div class="titleBox">
      <div class="anliTitle" style="margin-top:138px">场景功能</div>
      <div class="lineCss"></div>
    </div>

    <div class="bottomParent">
      <div class="bottomLeft">
        <div class="bottomRightTitle bottomRightTitleTwo">数字餐牌</div>
        <div
          class="bottomRightText bottomRightTextTwo"
        >原有电子屏接入数拓智屏os，变身数字餐牌。后台提供海量定制模板，可根据营销活动选择；接入智能外设，无人时联屏展示动态广告，识别到人可单屏展示价目表，联屏/单屏可自动切换。</div>
      </div>

      <div class="bottomRight" style="width:50%;">
        <img :src="wanDaContent3" alt>
      </div>
    </div>

    <!-- 场景解析 end -->

    <!-- end -->
    <Footer></Footer>
  </div>
</template>
<script>
import Top from "@/components/top.vue";
import Footer from "@/components/footer.vue";
import bgImg from "@/assets/images/costaTop.png";
import productLeft1 from "@/assets/images/costa1.png";

import wanDaContent2 from "@/assets/images/teBuContent1.png";
import wanDaContent3 from "@/assets/images/costa2.png";
import wanDaContent4 from "@/assets/images/teBuContent3.png";
import detailListIcon1 from "@/assets/images/teBuIcon1.png";
import detailListIcon2 from "@/assets/images/teBuIcon2.png";
import detailListIcon3 from "@/assets/images/teBuIcon3.png";
import detailListIcon4 from "@/assets/images/teBuIcon4.png";
import detailListIcon5 from "@/assets/images/teBuIcon5.png";
import teBuContent5 from "@/assets/images/gxg4.png";
import teBuContent6 from "@/assets/images/teBuContent6.png";
import teBuContent7 from "@/assets/images/teBuContent7.png";
import northFace2 from "@/assets/images/gxg2.png";
import piglet5 from "@/assets/images/gxg5.png";

import Bread from "@/components/bread.vue";

export default {
  name: "CaseCosta",
  components: {
    Top,
    Footer,
    Bread
  },
  data() {
    return {
      northFace2: northFace2,
      teBuContent5: teBuContent5,
      teBuContent6: teBuContent6,
      teBuContent7: teBuContent7,
      toBreadChild: ["案例", "小猪班纳"],
      bgImg: bgImg,
      wanDaContent2: wanDaContent2,
      wanDaContent3: wanDaContent3,
      wanDaContent4: wanDaContent4,
      productLeft1: productLeft1,
      piglet5: piglet5,
      detailListIcon1: detailListIcon1,
      detailListIcon2: detailListIcon2,
      detailListIcon3: detailListIcon3,
      detailListIcon4: detailListIcon4,
      detailListIcon5: detailListIcon5
    };
  }
};
</script>
<style scoped>
/* start */
.content {
  position: relative;
}

.bgImgCss {
  width: 100%;
  /* height: 788px; */
}

.imgSrcCss {
  width: 100%;
}

.contentPosition {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: auto;
  width: 888px;
  height: 90px;
  text-align: center;
}

.contentTop {
  font-size: 8.7rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  margin-bottom: 37px;
}

.contentBottom {
  text-align: center;
  font-size: 3rem;
  font-family: PingFangSC-Light;
  font-weight: 300;
  color: rgba(255, 255, 255, 1);
  line-height: 45px;
}

/* end  */
/* start */
.anliTitle {
  font-size: 3.6rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(0, 0, 0, 1);
  line-height: 40px;
}

.lineCss {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin: auto;
  margin-top: 22px;
}
.lineCss1 {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
  margin-bottom: 40px;
}
.lineCssTwo {
  width: 80px;
  height: 5px;
  background: rgba(252, 200, 0, 1);
  margin-top: 22px;
}

.titleBox {
  text-align: center;
  margin-top: 100px;
}
.titleBox1 {
}
.titleBoxTwo {
  margin-top: 100px;
  width: 80%;
  margin: auto;
}

/* end */
.productParent::after {
  content: "";
  display: block;
  clear: both;
}
.productParent {
  width: 70%;
  margin: auto;
}

.productLeft {
  width: 44%;
  padding-left: 3%;
  float: left;
}

.productLeft img {
  width: 98%;
  /* max-width: 542px; */
}

.productRight {
  width: 44%;
  padding-left: 5%;
  float: left;
}

.productRightTitle {
  text-indent: 3.8rem;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin-top: 2%;
  width: 82%;
}

.productRightText {
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 33px;
  margin-top: 30px;
}

.marginTop109 {
  margin-top: 45px;
}

.grayBoxText {
  width: 64%;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 40px;
  margin: auto;
  margin-bottom: 30px;
  margin-top: 68px;
  text-indent: 40px;
}

.grayBox {
  background: rgba(240, 240, 240, 1);
  margin-top: 170px;
  padding-bottom: 68px;
  padding-top: 70px;
}

.detailList {
  display: flex;
  width: 76%;
  margin: auto;
}

.detailBox {
  width: 25%;
  text-align: center;
  font-size: 2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(136, 136, 136, 1);
  line-height: 40px;
}

.bottomParent {
  width: 70%;
  margin: auto;
}
.bottomParent::after {
  content: "";
  display: block;
  clear: both;
}
.bottomLeft {
  width: 50%;
  float: left;
  margin-top: 84px;
}
.bottomLeft img {
  width: 97%;
  /* max-width: 586px; */
}
.bottomRight img {
  width: 97%;
  /* max-width: 586px; */
}
.bottomRight {
  margin-top: 84px;
  width: 46%;
  float: right;
}
.bottomRightTitle {
  font-size: 3.2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  margin-top: 6%;
  padding-left: 10%;
}
.bottomRightText {
  margin-top: 4%;
  font-size: 2rem;
  font-family: PingFangSC-Regular;
  font-weight: 400;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
}
.bottomRightTitleTwo {
}
.bottomRightTextTwo {
  width: 80%;
  margin: auto;
  margin-top: 6%;
}
.paddingRight {
  padding-right: 5%;
}
.rightImgCss {
  width: 100%;
  max-width: 618px;
}
.gapCss {
  font-size: 3.2rem;
  font-family: PingFangSC-Medium;
  font-weight: 500;
  color: rgba(51, 51, 51, 1);
  line-height: 30px;
  text-align: center;
  margin-top: 139px;
}
</style>



// WEBPACK FOOTER //
// src/view/CaseCosta.vue